import React from 'react';
import { useFormikContext } from 'formik';

import { useStyles } from '~/assets/styles';
import CheckboxFormik from '~/components/CheckboxFormik';
import MenuItem from '~/components/core/Atomic/MenuItem';
import { DatePickerTextFieldFormik, TextFieldFormik } from '~/components/TextFieldFormik';
import { localTimeToViewTime } from '~/DateTimeUtils';

import { SHARED_EXPORT_TEXTS } from './texts';

export const HOURS = [
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
];

interface HourAndEndDateValues {
  export_hour: string;
  is_end_date?: boolean;
  end_date?: string;
}

const HourAndEndDateFields: React.FC = () => {
  const { classes } = useStyles();
  const { isSubmitting, values } = useFormikContext<HourAndEndDateValues>();

  return (
    <>
      <TextFieldFormik
        id="export_hour"
        label={SHARED_EXPORT_TEXTS.HOUR_LABEL}
        className={classes.textField}
        select
        fullWidth
        disabled={isSubmitting}
      >
        {/* @ts-expect-error TextFieldFormik types don't support MenuItem children when used as select */}
        {HOURS.map((hour) => (
          <MenuItem key={hour} value={hour}>
            {localTimeToViewTime(hour)}
          </MenuItem>
        ))}
      </TextFieldFormik>
      <CheckboxFormik id="is_end_date" label={SHARED_EXPORT_TEXTS.END_DATE_CHECKBOX} disabled={isSubmitting} />
      {values.is_end_date && (
        <DatePickerTextFieldFormik
          id="end_date"
          label={SHARED_EXPORT_TEXTS.END_DATE_LABEL}
          className={classes.textField}
          disablePast
          fullWidth
          disabled={isSubmitting}
          clearable
        />
      )}
    </>
  );
};

export default HourAndEndDateFields;
